// extracted by mini-css-extract-plugin
module.exports = {"container":"EarlyDocumentsCards_container__CtJox"};